/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  FormInstance,
  Input,
  InputNumber,
  Layout,
  Modal,
  Row,
  Select,
  Space,
  Typography,
  message,
} from "antd";
import { useDispatch } from "react-redux";
import { fetchBranchCropVarieties } from "../../redux/common/common.actions";
import { useSelector } from "react-redux";
import {
  CaretDownOutlined,
  LeftCircleOutlined,
  CopyrightOutlined,
} from "@ant-design/icons";
import {
  checkUserExists,
  generateOtp,
  registration,
  verifyOtp,
} from "../../redux/user/user.actions";
import background from "../../assets/logo.png";
import packageJson from "../../../package.json";
import router from "../../components/History/index.component";
import dayjs from "dayjs";
import { emailValidator, textValidator } from "../../utils/utility-functions";
import { SHA256 } from "crypto-js";
import Checkbox from "antd/es/checkbox/Checkbox";
import { Document, Page } from "react-pdf";

const { Option } = Select;
const { Content, Footer } = Layout;
const { Title, Text } = Typography;

const Registration: React.FC<any> = () => {
  const [form] = Form.useForm();
  const [formOtp] = Form.useForm();
  const {} = formOtp;
  const dispatch = useDispatch();
  const cropList = useSelector((state: any) => state.common.crops);
  const branchList = useSelector((state: any) => state.common.branches);

  const [disable, setDisable] = React.useState(false);
  const [panNumber, setPanNumber] = React.useState("");
  const [otpModal, setOtpModal] = React.useState(false);
  const [otpSMSModal, setOtpSMSModal] = React.useState(false);
  // const [phoneValidated, setPhoneValidated] = React.useState(false);
  const [emailValidated, setEmailValidated] = React.useState(false);
  const [tcModal, setTCOpen] = React.useState(false);
  const [ppModal, setPPOpen] = React.useState(false);
  const [primaryBranchList, setPrimaryBarnch] = React.useState([]);
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [submitLoader, setSubmitLoader] = React.useState(false);

  const onFinish = async (values: any) => {
    const body = {
      ...values,
      GST_number: values.GST_number || null,
      fax_no: values.fax_no || null,
      submission_type: 2,
      registered_as: "EXISTING_TRADER",
      member_to_trader: null,
      declaration_date: dayjs().format("YYYY-MM-DD"),
    };
    const status: boolean = await dispatch(registration(body));
    if (status) {
      form.resetFields();
      setDisable(false);
      setEmailValidated(false);
      // setPhoneValidated(false);
      router.navigate("/signin");
    } else {
      return;
    }
  };

  const validateEmail = async (name: string) => {
    setButtonLoader(true);
    form
      .validateFields([name])
      .then(async (response) => {
        const status: boolean = await dispatch(generateOtp(response));
        if (status === true) {
          name == "email" ? setOtpModal(true) : setOtpSMSModal(true);
        }
      })
      .catch((error) => {
        message.error("Please enter valid Input...");
      })
      .finally(() => setButtonLoader(false));
  };

  const closeHandler = () => {
    formOtp.resetFields();
    setOtpModal(false);
    setOtpSMSModal(false);
  };

  const onOtpModalFinish = async (values) => {
    try {
      setSubmitLoader(true);
      const params = {
        ...(values?.email_otp
          ? {
              email: form.getFieldValue("email"),
              email_otp: `${values?.email_otp}`,
            }
          : {
              contact_number: form.getFieldValue("contact_number"),
              sms_otp: `${values?.sms_otp}`,
            }),
      };
      const response = await dispatch(verifyOtp(params));
      if (
        response.status === "success" &&
        values.email_otp &&
        SHA256(`${values.email_otp}`).toString() ===
          response.data.hashed_email_otp
      ) {
        setOtpModal(false);
        setEmailValidated(true);
        formOtp.resetFields();
      } else if (
        response.status === "success" &&
        values.sms_otp &&
        SHA256(`${values.sms_otp}`).toString() === response.data.hashed_sms_otp
      ) {
        setOtpSMSModal(false);
        // setPhoneValidated(true);
        formOtp.resetFields();
      }
    } catch (error: any) {
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, please try again later",
        5
      );
    } finally {
      setSubmitLoader(false);
    }
  };
  const handleSelectChange = (value, option) => {
    setPrimaryBarnch(option);
    form.resetFields(["primary_branch"]);
  };

  useEffect(() => {
    dispatch(fetchBranchCropVarieties(true));
  }, []);

  return (
    <Layout>
      <Modal
        title="Confirm OTP Details"
        onCancel={closeHandler}
        className="basicModal"
        open={otpModal || otpSMSModal}
        footer={null}
        centered
        style={{ minWidth: 100 }}
        styles={{ body: { textAlign: "center", width: "100%" } }}
      >
        <Form
          name="basic"
          style={{ width: "100%" }}
          form={formOtp}
          labelWrap
          onFinish={onOtpModalFinish}
          autoComplete="off"
          colon={true}
        >
          <Form.Item
            label="OTP"
            name={otpModal ? "email_otp" : "sms_otp"}
            rules={[
              {
                required: true,
                message: "Enter valid otp!",
              },
              { pattern: /^[0-9]{6}$/, message: "Only 6 digits accepted!" },
            ]}
          >
            <Input
              style={{
                height: 30,
                borderRadius: "20px",
                width: "100%",
              }}
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{ float: "right", borderRadius: "20px" }}
              disabled={submitLoader}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Content
        style={{
          padding: 0,
          minHeight: "100vh",
          backgroundColor: "rgb(255, 255, 255, 0.9)",
          // backgroundImage: `url(${background})`,
          // backgroundPosition: "top",
          // backgroundRepeat: "space repeat",
          // backgroundAttachment: "fixed",
          // backgroundBlendMode: "color-burn",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Card
          style={{
            width: "80%",
            backgroundColor: "rgba(255,255,255,1)",
            boxShadow: "8px 10px 15px 2px rgba(0, 0, 0, 0.6)",
          }}
          variant={"borderless"}
        >
          <Row>
            <Col span={disable ? 24 : 17}>
              <Title
                level={2}
                style={{
                  padding: 0,
                  margin: 0,
                  marginBottom: "0.1em",
                }}
              >
                Existing Vendor Registration
              </Title>
              <Text strong>Unlock Exclusive Application Access</Text>
            </Col>
            {!disable && (
              <Col span={7} style={{ textAlign: "end" }}>
                <Space
                  style={{ alignItems: "baseline" }}
                  size={3}
                  onClick={() => {
                    router.navigate("/signin");
                  }}
                >
                  <LeftCircleOutlined
                    style={{ color: "#1677FF", cursor: "pointer" }}
                  />
                  <Title
                    level={5}
                    style={{
                      color: "#1677FF",
                      cursor: "pointer",
                      padding: 0,
                      margin: 0,
                    }}
                  >
                    Return to Sign In
                  </Title>
                </Space>
              </Col>
            )}
          </Row>
          <Form
            form={form}
            style={{ marginTop: "1.5em" }}
            name="registration"
            labelAlign="left"
            labelCol={{ span: 7 }}
            size="middle"
            onFinish={onFinish}
            autoComplete="off"
            scrollToFirstError
            colon={false}
          >
            <Row gutter={24}>
              <Col md={12} xs={24}>
                <Form.Item
                  name="PAN_no"
                  label="PAN No."
                  tooltip="What is your 10 digit Personal Account Number?"
                  rules={[
                    {
                      required: true,
                      message: "Please input PAN Number",
                    },
                    {
                      pattern: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
                      message: "Please input valid PAN Number",
                    },
                    {
                      async validator(_, value) {
                        if (
                          value &&
                          value.trim().length === 10 &&
                          new RegExp(
                            /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/
                          ).test(value)
                        ) {
                          if (
                            panNumber !== value &&
                            new RegExp(
                              /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/
                            ).test(value)
                          ) {
                            setPanNumber(value);
                            const status: boolean = await dispatch(
                              checkUserExists({
                                PAN_no: value.toUpperCase(),
                                tm: false,
                              })
                            );
                            if (status) {
                              return Promise.resolve();
                            } else {
                              setPanNumber("");
                              form.resetFields(["PAN_no"]);
                              return Promise.reject(
                                "Pan number already exists."
                              );
                            }
                          }
                        } else {
                          return Promise.reject();
                        }
                      },
                    },
                  ]}
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled={disable}
                    onPaste={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                    onCopy={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                    onChange={(e) => {
                      if (e.target.value) {
                        const value = e.target.value.toUpperCase();
                        form.setFieldValue("PAN_no", value);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  name="GST_number"
                  label="GST No."
                  tooltip="What is your 15 digit Goods and Services Taxpayer Identification Number?"
                  rules={[
                    {
                      pattern:
                        /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/,
                      message: "Please input valid GST Number",
                    },
                  ]}
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled={disable}
                    onPaste={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                    onCopy={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col md={12} xs={24}>
                <Form.Item
                  name="name"
                  label="Name"
                  tooltip="What is your name?"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please input your name!",
                      whitespace: true,
                    },
                    {
                      pattern: /^([a-zA-Z0-9 ]*)$/,
                      message: "Please input valid name",
                    },
                  ]}
                >
                  <Input allowClear spellCheck={false} disabled={disable} />
                </Form.Item>
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  name="name_firm"
                  label="Firm"
                  hasFeedback
                  tooltip="What is the name of your firm/entity?"
                  rules={[
                    {
                      required: true,
                      message: "Please input your firm/entity name!",
                      whitespace: true,
                    },
                    {
                      pattern: /^([a-zA-Z0-9 ]*)$/,
                      message: "Please input valid firm name",
                    },
                  ]}
                >
                  <Input spellCheck={false} allowClear disabled={disable} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col md={12} xs={24}>
                <Form.Item
                  name="contact_number"
                  label="Phone"
                  tooltip="What is your Phone Number?"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please input your phone number!",
                    },
                    {
                      pattern: /^[6789]\d{9}$/,
                      message: "Please input valid phone number!",
                    },
                  ]}
                >
                  <Space.Compact style={{ width: "100%" }}>
                    <Input
                      addonBefore="+91"
                      style={{ width: "100%" }}
                      allowClear
                      disabled={disable}
                      // onChange={() => {
                      //   setPhoneValidated(false);
                      // }}
                    />
                    {/* <Button
                      type="primary"
                      onClick={() => validateEmail("contact_number")}
                      disabled={phoneValidated}
                      loading={buttonLoader}
                      // icon={
                      //   phoneValidated && (
                      //     <CheckCircleFilled style={{ color: "lawngreen" }} />
                      //   )
                      // }
                      style={
                        phoneValidated
                          ? {
                              backgroundColor: "green",
                              borderColor: "green",
                              color: "white",
                            }
                          : {
                              backgroundColor: "#faad14",
                              borderColor: "#faad14",
                            }
                      }
                    >
                      {phoneValidated ? "Validated" : "Validate"}
                    </Button> */}
                  </Space.Compact>
                </Form.Item>
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  name="fax_no"
                  label="Fax No."
                  tooltip="What is your FAX Number?"
                  hasFeedback
                  rules={[
                    {
                      pattern:
                        /^(\+91[\s\-]?)?0?[1-9]\d{2}[\s\-]?\d{3}[\s\-]?\d{4}$/,
                      message: "Please input valid fax number!",
                    },
                  ]}
                >
                  <Input allowClear disabled={disable} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col md={12} xs={24}>
                <Form.Item
                  name="email"
                  label="E-mail"
                  tooltip="What is your E-mail id?"
                  hasFeedback
                  rules={[
                    {
                      validator: emailValidator,
                    },
                    {
                      required: true,
                      message: "Please input your E-mail!",
                    },
                  ]}
                >
                  <Space.Compact style={{ width: "100%" }}>
                    <Input
                      spellCheck={false}
                      disabled={disable}
                      autoComplete="off"
                      onChange={() => {
                        setEmailValidated(false);
                      }}
                    />
                    <Button
                      type="primary"
                      onClick={() => validateEmail("email")}
                      disabled={emailValidated}
                      loading={buttonLoader}
                      // icon={
                      //   emailValidated && (
                      //     <CheckCircleFilled style={{ color: "lawngreen" }} />
                      //   )
                      // }
                      style={
                        emailValidated
                          ? {
                              backgroundColor: "green",
                              borderColor: "green",
                              color: "white",
                            }
                          : {
                              backgroundColor: "#faad14",
                              borderColor: "#faad14",
                            }
                      }
                    >
                      {emailValidated ? "Validated" : "Validate"}
                    </Button>
                  </Space.Compact>
                </Form.Item>
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  label="Type"
                  name="nature_of_supplier"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please select your account type!",
                    },
                  ]}
                  tooltip="What is your account type?"
                  initialValue={1}
                >
                  <Select disabled={disable}>
                    <Option value={1}>Trader</Option>
                    <Option value={5}>Broker</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col md={12} xs={24}>
                <Form.Item
                  name="address"
                  label="Address"
                  hasFeedback
                  tooltip="What is your address?"
                  rules={[
                    { required: true, message: "Please input your address!" },
                    {
                      validator: textValidator,
                    },
                  ]}
                >
                  <Input.TextArea
                    showCount
                    spellCheck={false}
                    maxLength={100}
                    style={{ resize: "none" }}
                    disabled={disable}
                  />
                </Form.Item>
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  name="location"
                  hasFeedback
                  label="District"
                  tooltip="What is your district?"
                  rules={[
                    { required: true, message: "Please input your district!" },
                    {
                      validator: textValidator,
                    },
                  ]}
                >
                  <Input
                    spellCheck={false}
                    maxLength={100}
                    disabled={disable}
                    style={{ resize: "none" }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col md={12} xs={24}>
                <Form.Item
                  name="state"
                  label="State"
                  rules={[
                    { required: true, message: "Please input your state!" },
                  ]}
                  tooltip="What is your state?"
                  hasFeedback
                >
                  <Select disabled={disable}>
                    <Option value="Andhra Pradesh">Andhra Pradesh</Option>
                    <Option value="Andaman and Nicobar Islands">
                      Andaman and Nicobar Islands
                    </Option>
                    <Option value="Arunachal Pradesh">Arunachal Pradesh</Option>
                    <Option value="Assam">Assam</Option>
                    <Option value="Bihar">Bihar</Option>
                    <Option value="Chandigarh">Chandigarh</Option>
                    <Option value="Chhattisgarh">Chhattisgarh</Option>
                    <Option value="Dadar and Nagar Haveli">
                      Dadar and Nagar Haveli
                    </Option>
                    <Option value="Daman and Diu">Daman and Diu</Option>
                    <Option value="Delhi">Delhi</Option>
                    <Option value="Lakshadweep">Lakshadweep</Option>
                    <Option value="Puducherry">Puducherry</Option>
                    <Option value="Goa">Goa</Option>
                    <Option value="Gujarat">Gujarat</Option>
                    <Option value="Haryana">Haryana</Option>
                    <Option value="Himachal Pradesh">Himachal Pradesh</Option>
                    <Option value="Jammu and Kashmir">Jammu and Kashmir</Option>
                    <Option value="Jharkhand">Jharkhand</Option>
                    <Option value="Karnataka">Karnataka</Option>
                    <Option value="Kerala">Kerala</Option>
                    <Option value="Madhya Pradesh">Madhya Pradesh</Option>
                    <Option value="Maharashtra">Maharashtra</Option>
                    <Option value="Manipur">Manipur</Option>
                    <Option value="Meghalaya">Meghalaya</Option>
                    <Option value="Mizoram">Mizoram</Option>
                    <Option value="Nagaland">Nagaland</Option>
                    <Option value="Odisha">Odisha</Option>
                    <Option value="Punjab">Punjab</Option>
                    <Option value="Rajasthan">Rajasthan</Option>
                    <Option value="Sikkim">Sikkim</Option>
                    <Option value="Tamil Nadu">Tamil Nadu</Option>
                    <Option value="Telangana">Telangana</Option>
                    <Option value="Tripura">Tripura</Option>
                    <Option value="Uttar Pradesh">Uttar Pradesh</Option>
                    <Option value="Uttarakhand">Uttarakhand</Option>
                    <Option value="West Bengal">West Bengal</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  name="postal_code"
                  label="Postal Code"
                  tooltip="What is your postal code?"
                  rules={[
                    {
                      required: true,
                      message: "Please input your postal code!",
                    },
                    {
                      pattern: /^\d{6}$/,
                      message: "Please input valid postal code.",
                    },
                  ]}
                  hasFeedback
                >
                  <Input allowClear disabled={disable} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col md={8} xs={12}>
                <Form.Item
                  label="Branch(s)"
                  name="registered_sap_branch"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please select your trading branch(s)!",
                    },
                  ]}
                  tooltip="What is your trading branch(s)?"
                >
                  <Select
                    disabled={disable}
                    mode="multiple"
                    options={branchList}
                    fieldNames={{
                      label: "name",
                      value: "id",
                      options: "options",
                    }}
                    onChange={handleSelectChange}
                    maxTagCount="responsive"
                    showSearch={false}
                    showArrow={true}
                    allowClear
                    suffixIcon={<CaretDownOutlined />}
                  />
                </Form.Item>
              </Col>
              <Col md={10} xs={12}>
                <Form.Item
                  label="Primary branch"
                  name="primary_branch"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please select your primary branch!",
                    },
                  ]}
                  tooltip="What is your primary branch?"
                >
                  <Select
                    disabled={disable}
                    options={primaryBranchList}
                    fieldNames={{
                      label: "name",
                      value: "id",
                      options: "options",
                    }}
                    maxTagCount="responsive"
                    showSearch={false}
                    showArrow={true}
                    allowClear
                    suffixIcon={<CaretDownOutlined />}
                  />
                </Form.Item>
              </Col>
              <Col md={6} xs={12}>
                <Form.Item
                  label="Crop"
                  name="crops"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please select your trading crop!",
                    },
                  ]}
                  tooltip="What is your trading crop?"
                >
                  <Select
                    mode="multiple"
                    disabled={disable}
                    options={cropList}
                    maxTagCount="responsive"
                    fieldNames={{
                      label: "name",
                      value: "id",
                      options: "options",
                    }}
                    showSearch={false}
                    showArrow={true}
                    allowClear
                    suffixIcon={<CaretDownOutlined />}
                  />
                </Form.Item>
              </Col>
            </Row>
            {disable && (
              <Space>
                <Form.Item
                  name="tc_pp_consent"
                  valuePropName="checked"
                  style={{
                    marginBottom: 0,
                  }}
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Checkbox />
                </Form.Item>
                <div>
                  I agree to{" "}
                  <Typography.Link onClick={() => setTCOpen(true)}>
                    Terms and Conditions
                  </Typography.Link>{" "}
                  and{" "}
                  <Typography.Link onClick={() => setPPOpen(true)}>
                    Privacy Policy
                  </Typography.Link>
                </div>
              </Space>
            )}
            <Form.Item
              wrapperCol={{ span: 16 }}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: 0,
              }}
            >
              <SubmitButton
                form={form}
                setDisabled={setDisable}
                disabled={!emailValidated}
                // disabled={!emailValidated || !phoneValidated}
              />
            </Form.Item>
          </Form>
        </Card>
      </Content>
      <Footer
        style={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          display: "flex",
          justifyContent: "end",
          backgroundColor: "transparent",
          padding: 0,
          pointerEvents: "none",
        }}
      >
        <Text
          strong
          style={{
            color: "#bfbfbf",
          }}
        >
          <CopyrightOutlined /> ITC Limited v{packageJson.version}
        </Text>
      </Footer>
      <Modal
        title="Terms & Conditions"
        footer={false}
        open={tcModal}
        onCancel={() => {
          setTCOpen(false);
        }}
        centered
        width={700}
      >
        <div
          style={{
            overflow: "scroll",
            overflowX: "hidden",
            height: "100vh",
          }}
        >
          <Document
            file="./ABD_Terms_Conditions.pdf"
            onLoadSuccess={({ numPages }: { numPages: number }) => {
              // setNumPages(numPages);
            }}
          >
            {Array.from(new Array(3), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            ))}
          </Document>
        </div>
      </Modal>
      <Modal
        title="Privacy Policy"
        footer={false}
        open={ppModal}
        onCancel={() => {
          setPPOpen(false);
        }}
        centered
        width={700}
      >
        <div
          style={{
            overflow: "scroll",
            overflowX: "hidden",
            minHeight: "100vh",
          }}
        >
          <Document
            file="./ABD_Privacy_Policy.pdf"
            onLoadSuccess={({ numPages }: { numPages: number }) => {
              // setNumPages(numPages);
            }}
          >
            {Array.from(new Array(2), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            ))}
          </Document>
        </div>
      </Modal>
    </Layout>
  );
};

const SubmitButton = ({
  form,
  setDisabled,
  disabled,
}: {
  form: FormInstance;
  setDisabled: (status: boolean) => void;
  disabled;
}) => {
  const [submittable, setSubmittable] = React.useState(false);
  const [buttonText, setButtonText] = React.useState({
    ok: "Register",
    cancel: "Review",
  });
  const [cancelVisibility, setCancelVisibility] = React.useState(false);
  const values = Form.useWatch([], form);

  React.useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setSubmittable(true);
      },
      () => {
        setSubmittable(false);
      }
    );
  }, [values]);

  const changeHandler = () => {
    setDisabled(true);
    setCancelVisibility(true);
    setButtonText((prevState) => ({
      ...prevState,
      ok: `Confirm`,
    }));
  };

  const confirmHandler = () => {
    form.submit();
  };

  const cancelHandler = () => {
    setDisabled(false);
    setButtonText((prevState) => ({
      ...prevState,
      ok: `Register`,
    }));
    setCancelVisibility(false);
  };

  return (
    <Space direction="horizontal" size={10}>
      {cancelVisibility && (
        <Button type="default" danger htmlType="button" onClick={cancelHandler}>
          {buttonText.cancel}
        </Button>
      )}
      <Button
        type="primary"
        htmlType="button"
        disabled={
          disabled ||
          !submittable ||
          (cancelVisibility && values.tc_pp_consent !== true)
        }
        onClick={() => (!cancelVisibility ? changeHandler() : confirmHandler())}
      >
        {buttonText.ok}
      </Button>
    </Space>
  );
};

export default Registration;
